import React from "react";
import { ReactComponent as UnBlockingIcon } from "../../img/blocking_icons/unblocking.svg";
import { ReactComponent as BlockingDebtIcon } from "../../img/blocking_icons/blockingDebt.svg";
import { ReactComponent as BlockingForcedIcon } from "../../img/blocking_icons/blockingForced.svg";
import { ReactComponent as BlockingNonStatusIcon } from "../../img/blocking_icons/blockingNonStatus.svg";

const icons = {
  0: [<UnBlockingIcon />, "Не блокирован"],
  1: [<BlockingDebtIcon />, "Финансовая блокировка"],
  2: [<BlockingForcedIcon />, "Принудительная блокировка"],
  nonStatus: [<BlockingNonStatusIcon />, ""],
};

export const getBlockingStatusIcon = (blockingStatus, handleShowBlockingModal?: () => void) => {
  const icon =
    blockingStatus === null || blockingStatus === undefined
      ? undefined
      : icons[blockingStatus?.blockingTypeId]?.[0] || icons.nonStatus[0];
  return icon ? (
    <div
      onClick={(e) => {
        e.stopPropagation();
        handleShowBlockingModal && handleShowBlockingModal();
      }}
      style={{ marginRight: "5px", width: "24px", height: "24px", cursor: "pointer" }}
    >
      {icon}
    </div>
  ) : (
    <div style={{ marginRight: "5px", width: "24px", height: "24px" }} />
  );
};

export const getBlockingStatusOnlyIcon = (blockingStatus) => {
  const icon =
    blockingStatus === null || blockingStatus === undefined
      ? undefined
      : icons[blockingStatus]?.[0] || icons.nonStatus[0];
  return icon ? (
    <div style={{ marginRight: "5px", width: "24px", height: "24px", cursor: "pointer" }}>
      {icon}
    </div>
  ) : (
    <div style={{ marginRight: "5px", width: "24px", height: "24px" }} />
  );
};
